import Vue from "vue";
import Notice from "@/components/notice/Notice.vue";
function kMessage(props) {
  const vm = new Vue({
    render: h => h(Notice, { props })
  }).$mount();

  document.body.appendChild(vm.$el);
  const comp = vm.$children[0];
  comp.remove = function() {
    document.body.removeChild(vm.$el);
    vm.$destroy();
  };
  return comp;
}

export default kMessage;



// WEBPACK FOOTER //
// ./src/common/js/kMessage.js